/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">All Teachers</h4>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">First Name</th>
                        <th scope="col">Last Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">City</th>
                        <th scope="col">Take Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(teacher) in teachers" :key="teacher._id">
                        <th>{{teacher.first_name}}</th>
                        <td>{{teacher.last_name}}</td>
                        <td>{{teacher.email}}</td>
                        <td>{{teacher.city}}</td>
                        <td>
                            <router-link :to="{ name: 'EditTeacher', params : {user_id : teacher._id} }">
                                <button class="btn btn-info btn-sm">Edit</button>
                            </router-link>

                            <button class="btn btn-success btn-sm " v-if="teacher.disabled" @click="activate(teacher._id)">Activate</button>

                            <button class="btn btn-dark btn-sm" v-if="teacher.disabled == false" @click="deactivate(teacher._id)">Deactivate</button>

                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
export default {
    name: 'AddClassroom',
    components: {

    },
    data() {
        return {
            teachers: [],
            page: this.$route.params.page,
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    methods: {
        addClassroom(teacher) {
            let data = {
                teacher: teacher,
            }
            const config = {
                headers: {
                    Authorization: "Bearer " + this.fastAdminToken,
                    'Content-Type': 'application/json'
                }
            }
            this.$toast.open({
                message: "Processing : Creating Classroom Please Wait...",
                type: 'info'
            })
            axios.post(this.$apiURI + "/classroom/create", data, config)
                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        this.$toast.open({
                            message: "Classroom Created Successfully",
                            type: 'success'
                        })
                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
        },

        activate(account_id) {
            const config = {
                headers: {
                    Authorization: "Bearer " + this.fastAdminToken,
                    'Content-Type': 'application/json'
                }
            }
            this.$toast.open({
                message: "Processing : Activating Account Please Wait...",
                type: 'info'
            })
            axios.post(this.$apiURI + "/account/" + account_id + "/activate", config)
                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        this.$toast.open({
                            message: "Account Activated Successfully",
                            type: 'success'
                        })
                        window.location.reload();
                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
        },
        deactivate(account_id) {
            const config = {
                headers: {
                    Authorization: "Bearer " + this.fastAdminToken,
                    'Content-Type': 'application/json'
                }
            }
            this.$toast.open({
                message: "Processing : Disabling Account Please Wait...",
                type: 'info'
            })
            axios.post(this.$apiURI + "/account/" + account_id + "/deactivate", config)
                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        this.$toast.open({
                            message: "Account Disabled Successfully",
                            type: 'success'
                        })
                        window.location.reload();
                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
        }
    },

    mounted() {
        this.$toast.open({
            message: "Processing : Loading Teachers Please Wait...",
            type: 'info'
        })

        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }
        axios.get(this.$apiURI + "/account/teachers", config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    
                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.teachers)
                    this.teachers = response.data.data.teachers
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    }
}
</script>
